import type { InputState } from "@neon-arena/shared";

/** Subset of touch controls that the merge function needs. */
export interface TouchState {
  throttle: number;
  brake: number;
  steer: number;
  handbrake: boolean;
  fire: boolean;
  boost: boolean;
  dropWeapon: boolean;
}

/**
 * Merge keyboard (or gamepad) state with touch state.
 * When touch is inactive the keyboard state is returned unchanged.
 * When touch is active:
 *   - analog axes (throttle, brake) take the maximum of both sources
 *   - steer: touch wins when non-zero, falls back to keyboard
 *   - booleans: OR of both sources
 *   - yaw: always from the non-touch source (keyboard/gamepad only)
 */
export function composeInputState(
  base: InputState,
  touch: TouchState,
  touchActive: boolean,
): InputState {
  if (!touchActive) return base;
  return {
    throttle: Math.max(base.throttle, touch.throttle),
    brake: Math.max(base.brake, touch.brake),
    steer: touch.steer !== 0 ? touch.steer : base.steer,
    handbrake: base.handbrake || touch.handbrake,
    fire: base.fire || touch.fire,
    fire2: base.fire2,
    boost: base.boost || touch.boost,
    dropWeapon: base.dropWeapon || touch.dropWeapon,
    yaw: base.yaw,
  };
}
